import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import DayBookConverter from "./DayBookConverter";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<DayBookConverter />}>
            <Route index element={<DayBookConverter />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
